var mentions_default = {
  "mentionPalette": "PRram",
  "mention": "FV0tw",
  "mentionViewer": "rDXgB",
  "mentionSuggestionsEntry": "fsRbI",
  "mentionSuggestionsEntryFocused": "_8PE1e",
  "mentionSuggestionsEntryText": "ydPp0",
  "mentionSuggestionsEntryAvatar": "Rexzv",
  "mentionSuggestions": "Wc1kV",
  "cursorDefault": "tBP0d",
  "cursorPointer": "_5WtjY"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
